import React, { Component } from 'react';
import classnames from 'classnames';
import { string, number, bool } from 'prop-types';
import { createSanitizedMarkup } from '@fiverr-private/futile';
import { getContext } from '@fiverr-private/fiverr_context';
import { ReviewsContext } from '../context';
import ExpandButton from './ExpandButton';

import './style.scss';

const SEE_MORE_TEXT_GAP_LENGTH = 60;

class Description extends Component {
    constructor(props) {
        super(props);
        this.onReadMoreClick = this.onReadMoreClick.bind(this);

        this.state = {
            textExpanded: false,
        };
    }

    componentDidMount() {
        const fiverrContext = getContext();
        this.setState({ fiverrContext });
    }

    componentDidUpdate(prevProps) {
        if (this.props.resetExpanded && this.props.resetExpanded !== prevProps.resetExpanded) {
            this.setState({
                textExpanded: false,
            });
        }
    }

    static contextType = ReviewsContext;

    onReadMoreClick() {
        this.setState({
            textExpanded: !this.state.textExpanded,
        });
    }

    render() {
        const { text, maxLength, displayLess, shouldHighlight, className } = this.props;

        const { textExpanded } = this.state;
        const { enableSearchFilter } = this.context;

        const isPartialTextLength = text.length > maxLength;
        const hideLessButton = !displayLess && textExpanded;
        const showReadMore = isPartialTextLength && !hideLessButton;
        const textIsCollapsible = text.length > maxLength + SEE_MORE_TEXT_GAP_LENGTH;
        let displayedText = text;

        if (showReadMore && textIsCollapsible) {
            if (!textExpanded) {
                const emptySpaceIndex = text.indexOf(' ', maxLength);
                const breakTextIndex = emptySpaceIndex === -1 ? maxLength : emptySpaceIndex;
                displayedText = `${text.substr(0, breakTextIndex)}... `;
            } else {
                displayedText = `${text} `;
            }
        }

        return (
            <div
                key={textExpanded ? 'expanded' : 'collapsed'}
                className={classnames(className, 'reliable-review-description', 'review-description')}
            >
                <p>
                    {!enableSearchFilter || !shouldHighlight ? (
                        displayedText
                    ) : (
                        <span
                            className="sanitized-text"
                            dangerouslySetInnerHTML={createSanitizedMarkup(displayedText)}
                        />
                    )}

                    {showReadMore && textIsCollapsible && (
                        <ExpandButton onClick={this.onReadMoreClick} textExpanded={textExpanded} />
                    )}
                </p>
            </div>
        );
    }
}

Description.defaultProps = {
    text: '',
    maxLength: Number.MAX_SAFE_INTEGER,
    displayLess: true,
    shouldHighlight: false,
    className: '',
    resetExpanded: false,
};

Description.propTypes = {
    text: string,
    maxLength: number,
    displayLess: bool,
    shouldHighlight: bool,
    className: string,
    resetExpanded: bool,
};

export default Description;
